module.exports = __webpack_public_path__ + "img/appAsset--customer-econ-ax.74723478.svg";